import { useEffect, useState } from "react";
import { AreaFiltro } from "../../../../types/Area";
import { useArea } from "../../../../hooks/useArea";
import FormSelectBox from "../../../../components/Form/FormSelectBox";
import FormInput from "../../../../components/Form/FormInput";
import { toast } from "react-toastify";


export const BuscarArea = () => {
    const { areaFiltroInitial, buscarAreas, filtro, handleFiltroArea } = useArea();
    const [filtroArea, setFiltroArea] = useState<AreaFiltro>(filtro);
    const [estados] = useState<any>(
        [
            {
                'id': 'true',
                'valor': 'ACTIVA'
            },
            {
                'id': 'false',
                'valor': 'INACTIVA'
            }
        ]);

    const buscar = (filtroBusqueda: AreaFiltro) => {
        buscarAreas(filtroBusqueda)
            .catch((error: any) => {
                if (error?.response?.status === 403) {
                    toast.error('No tiene permisos para consultar Áreas');
                }
            });
    }

    useEffect(() => {
        buscar(filtroArea);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        setFiltroArea({
            ...filtroArea,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        buscar(filtroArea);
        handleFiltroArea(filtroArea)
    }

    const handleClean = () => {
        setFiltroArea(areaFiltroInitial);
        handleFiltroArea(areaFiltroInitial);
        buscar(areaFiltroInitial);
    };

    return (

        <div className="card">
            <form id="dto" className="form-horizontal" action="buscarAreas" method="post">
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />

                    <div className="row mt-2">

                        <FormInput
                            id={'nombre'}
                            label={'Nombre'}
                            name={'nombre'}
                            placeholder={'Nombre'}
                            value={filtroArea.nombre || ''}
                            onChange={handleChange}
                            maxLength={100}
                        />

                        <FormSelectBox
                            title={'Estado'}
                            label={'estado'}
                            id={'activo'}
                            name={'activo'}
                            onChange={handleChange}
                            optionId={'id'}
                            optionLabel={'valor'}
                            value={filtroArea.activo === null || filtroArea.activo === undefined ? '' : String(filtroArea.activo)}
                            options={estados}
                            seleccionarText="TODOS"
                        />

                    </div>

                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">

                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit" onClick={handleSubmit}>
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    )
}
